// プレーヤの永続設定。グローバル設定は kv['playerPrefs']、項目ごと（トラック選択・字幕オフセット）は kv['pi:<hash>']。
import { kvGet, kvSet } from './db.js'

const KEY = 'playerPrefs'
const DEFAULTS = {
  skipSeconds: 5, // ◀◀ ▶▶ の移動秒数
  speed: 1,
  volume: 1,
  subPos: 250, // 字幕の下端からの距離(px)。大きいほど上へ。既定は操作盤の上あたり。up/downで増減
  playMode: 'stop', // 終端の挙動: stop=停止 / order=次へ / shuffle=ランダム次 / repeat=くり返し
  // 字幕の見た目（メイン字幕。サブはサイズに連動）
  subSize: 22, // メイン字幕の文字サイズ(px)
  subWeight: 700, // 太さ: 400=標準 / 700=太字
  subColor: '#ffe14d', // メイン字幕の色
  subOutline: true, // 縁取り(黒い影)で映像上でも読みやすく
}

let cache = null
export async function getPrefs() {
  if (!cache) cache = { ...DEFAULTS, ...((await kvGet(KEY)) || {}) }
  return cache
}
export async function setPref(k, v) {
  const p = await getPrefs()
  p[k] = v
  await kvSet(KEY, p)
}

// 項目ごと: { mainId, subId, offset }
export async function getItemPrefs(hash) {
  return (await kvGet('pi:' + hash)) || {}
}
export async function setItemPrefs(hash, patch) {
  const cur = await getItemPrefs(hash)
  const next = { ...cur, ...patch }
  await kvSet('pi:' + hash, next)
  return next
}
